import React, { useEffect, useState, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
    setLoading,
    storeHeaderActions,
} from 'store/reducers/mainSlice';
import { FaSearch } from 'react-icons/fa';
import Filter from 'ui-component/filter-menu/Filter';
import moment from 'moment';
import { Skeleton } from '@mui/material';
import toast from 'react-hot-toast';
import ExportListItemsModal from 'ui-component/ExportListItemsModal';

// import DeleteConfirmation from 'ui-component/confirmation-dialogs/deleteConfirmation/DeleteConfirmation';
import DeleteConfirmationGlass from 'ui-component/confirmation-dialogs/deleteConfirmation/DeleteConfirmationGlass';
import { CommonDateOnlyFormat } from 'helpers/common.helper';
import { TbDatabaseExclamation } from 'react-icons/tb';
import { useQueryClient } from 'react-query';

import usePageTitle from 'hooks/usePageTitle';

import NoRecordFoundIcon from 'assets/images/icons/no-records-found.svg';
import StatusBadge from 'ui-component/StatusBadge';
import useIsMobile from 'utils/isMobileUtils';
import ExportListItemsModalMobile from 'ui-component/ExportListItemsModalMobile';
import SortableHeader from 'ui-component/SortableHeader';

// ✅ Clear
const index = () => {
	const [setPageTitle] = usePageTitle('Invoices');
	
    const history = useNavigate();
    const selectedCurrency = useSelector((state) => state.main.selectedCurrency);
    const [show, setShow] = useState('');
    const [activeComponent, setActiveComponent] = useState('Invoice');
    const dispatch = useDispatch();

    const [searchField, setSearchField] = useState();
    const [searchValue, setSearchValue] = useState();
    const [searchTimeout, setSearchTimeout] = useState(null);
    const [filters, setFilters] = useState([]);
    const [activeFilters, setActiveFilters] = useState({});
    const [sortByFilter, setSortByFilter] = useState();
    const headerActions = useSelector((state) => state.main.headerActions);


    const storedSearch = useSelector((state) => state.main.searchQuotation);
    const storedFilter = useSelector((state) => state.main.filterQuotation);

    const [dataList, setDataList] = useState([]);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const tableRef = useRef();
    const [showPreloadingRows, setShowPreloadingRows] = useState(true);
    const [totalRecords, setTotalRecords] = useState(0);



    const [checkedItems, setCheckedItems] = useState([]);
    const [showDeleteButton, setShowDeleteButton] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    

    useEffect(() => {
        // Only run fetchData after user stops typing (debounced by searchTimeout)
        // setIsLoading(true);
        if (searchTimeout) {
            clearTimeout(searchTimeout);
        }

        const timeout = setTimeout(() => {
            const fetchData = async () => {
                if (storedSearch) {
                    await handleSearch({ target: { value: storedSearch } });
                }
                setDataList([]);
                initializeData();
                getFiltersList();
            };
            fetchData();
        }, 500); // 500ms debounce

        setSearchTimeout(timeout);

        // Cleanup on unmount or before next effect run
        return () => clearTimeout(timeout);
        // Only trigger when these change
    }, [storedSearch, searchField, storedFilter]);

    useEffect(() => {
        setIsLoading(true);
    }, [activeFilters])
    useEffect(() => {
        const handleScroll = () => {
            if (!tableRef.current || showPreloadingRows || !hasMore) return;
            const { scrollTop, scrollHeight, clientHeight } = tableRef.current;
            if (scrollTop + clientHeight >= scrollHeight - 10) {
                loadMoreData();
            }
        };
        const currentRef = tableRef.current;
        if (currentRef) {
            currentRef.addEventListener('scroll', handleScroll);
        }
        return () => {
            if (currentRef) {
                currentRef.removeEventListener('scroll', handleScroll);
            }
        };
    }, [showPreloadingRows, hasMore, dataList]);


    const loadMoreData = () => {
        if (showPreloadingRows || !hasMore) return;
        setShowPreloadingRows(true);
        let request = {};
        request.page = page + 1;
        request.search = searchField?.length > 2 ? searchField : null;

        const currentActiveComponent = 2; // Invoice
        
        api.getClientQuotations(request, currentActiveComponent, activeFilters, searchField, sortByFilter).then((res) => {
            const nextPage = res?.data?.data?.meta?.current_page || request.page;
            const lastPage = res?.data?.data?.meta?.last_page || nextPage;
            if (nextPage > lastPage || res?.data?.data?.data?.length === 0) {
                setHasMore(false);
            } else {
                setDataList(prev => [...prev, ...res?.data?.data?.data || []]);
                setPage(nextPage);
            }
            setShowPreloadingRows(false);
        });
    };


    const initializeData = () => {
        // Initial load
        let request = {}
        request.page = 1;
        request.search = searchField?.length > 2 ? searchField : null;
        const currentActiveComponent = 3; // Invoice
        
        api.getClientQuotations(request, currentActiveComponent, activeFilters, searchField, sortByFilter).then((res) => {
            setDataList([]);
            setTimeout(() => {
                setDataList(res?.data?.data?.data || []);

                setHasMore(true);
                setPage(1);
                dispatch(setLoading(false));
                setIsLoading(false);
                setShowPreloadingRows(false);
                setTotalRecords(res?.data?.data?.total || 0);
            }, 300);
        });

    }

    const [selectedEstimate, setSelectedEstimate] = useState(null);

    const [paginationUrl, setPaginationUrl] = useState();

    const queryClient = useQueryClient();
    const [isLoading, setIsLoading] = useState(true);

    const [showQuickStats, setShowQuickStats] = useState(false);
    const [quickStatsLoading, setQuickStatsLoading] = useState(false);

    useEffect(() => {
        if (showQuickStats && !quickStatsLoading) {
            setQuickStatsLoading(true);
            api
                .quickSummarySalesOrder(
                    // statusTypeList?.find((item) => item?.name == activeComponent)?.id,
                    activeFilters,
                    searchField?.length > 2 ? searchField : null,
                    sortByFilter
                )
                .then((res) => {
                    setQuickStatsLoading(false);
                });
        }
    }, [showQuickStats]);


    const getFiltersList = () => {
        api.getClientQuotationFilter().then((res) => {
            setFilters(res.data);
        });
    };
    useEffect(() => {
        setPaginationUrl(null);
        setShowQuickStats(false);
        dispatch(
					storeHeaderActions({
						showQuickStats: false,
						showExport: false
					})
				);
    }, [activeComponent, activeFilters, searchField, sortByFilter]);

    const invalidateQuery = () => {
        queryClient.invalidateQueries({ queryKey: ['salesorders', activeComponent, activeFilters, searchField, paginationUrl, sortByFilter] });
        queryClient.invalidateQueries({ queryKey: ['salesorder-counter'] });
        selectedEstimate && setSelectedEstimate(null);
    };

    useEffect(() => {
        queryClient.invalidateQueries({ queryKey: ['salesorder-counter'] });
    }, [activeComponent]);

    const handleClose = () => {
        setShow(null);
        setShowDeleteModal(false);
    }

    const handleDeleteDraft = (id) => {
        toast.promise(
            api.deleteDraft(id).then((res) => {
                if (res.status) {
                    setShow('');
                    invalidateQuery();
                    setSelectedEstimate(null);
                }

                return res?.status ? res : abc;
            }),
            {
                loading: 'Deleting Draft...',
                success: (data) => `${data.message}`,
                error: <b>Failed to delete draft</b>
            }
        );
    };

    const handleCancelEstimate = (id) => {
        toast.promise(
            api.cancelEstimation(id).then((res) => {
                if (res.status) {
                    setShow('');
                    invalidateQuery();
                    setSelectedEstimate(null);
                }

                return res?.status ? res : abc;
            }),
            {
                loading: 'Canceling Estimate...',
                success: (data) => `${data.message}`,
                error: <b>Failed to cancel estimate</b>
            }
        );
    };

    const [exportCompIsLoading, setExportCompIsLoading] = useState(false);
    const [showExportModal, setShowExportModal] = useState(false);

    const exportListSubmitHandler = (selectedValues) => {
        setExportCompIsLoading(true);
        api.exportInvoice('', selectedValues, '', selectedCurrency).then((res) => {
            const newFileName = `Projectmix - Invoices`;
            if (res != 404) {
                var newBlob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                saveAs(newBlob, `${newFileName}.xlsx`);
                // toast.dismiss(downloading);
                setExportCompIsLoading(false);
                toast.success('Downloaded Completed!');
                setShowExportModal(false);
                dispatch(
                    storeHeaderActions({
                        showQuickStats: headerActions?.showQuickStats,
                        showExport: false
                    })
                );
            } else {
                setExportCompIsLoading(false);
                toast.error(res == 404 ? 'No Records Found!' : 'Download Failed!');
            }
        });
    };

    const handleSearch = (e) => {
        let text = e.target.value;
        
        setIsLoading(true);
        setSearchValue(text);
        if (searchTimeout) {
            clearTimeout(searchTimeout);
        }

        // Only update searchField after user stops typing for 500ms
        let timeout = setTimeout(() => {
            dispatch(storeSearchInvoice(text));
            setSearchField(text)	
        }, 500);

        setSearchTimeout(timeout);

    };

    useEffect(() => {
        if (headerActions?.showQuickStats) {
            setShowQuickStats(true);
        } else {
            setShowQuickStats(false);
        }

        if (headerActions?.showExport) {
            setShowExportModal(true);
        } else {
            setShowExportModal(false);
        }
    }, [headerActions]);

    const statusColorMap = {
        Draft: '#acacac', // gray
        Open: '#EBA562', // yellow
        Paid: '#00C13B', // green
        Canceled: '#E37560' // red
    };

    const isMobile = useIsMobile();


    const updateSortByStatus = (name) => {
        if (sortByFilter?.field == name) {
            setSortByFilter((e) => ({
                ...e,
                direction: e?.direction == 'asc' ? 'desc' : 'asc'
            }));
        } else {
            setSortByFilter((e) => ({
                field: name,
                direction: 'asc'
            }));
        }
    };
    

    useEffect(() => {
        // Show delete button if there are any checked items
        setShowDeleteButton(checkedItems.length > 0);
    }, [checkedItems]);

    const handleDeleteMultipleRecords = () => {
        toast.promise(
            api.deleteMultipleInvoice({ checkedItems }).then((res) => {
                if (res.status) {
                    setIsLoading(true);
                    setDataList([]);
                    initializeData();
                    setCheckedItems([]);
                    setShowDeleteButton(false);
                    setShowDeleteModal(false);
                }

                return res?.status ? res : abc;
            }),
            {
                loading: 'Deleting Records...',
                success: (data) => `${data.message}`,
                error: <b>Failed to delete records</b>
            }
        );
    }


    return (
		<>
			<div className="row">
				<div className="col-xl-12 col-lg-12">
					<div className="show-on-mobile new-page-header" style={{ position: 'relative' }}>
						<div className="client-header-bubble" />
						<div className="d-flex flex-column gap-2 " style={{ position: 'relative', zIndex: 1, paddingTop: 10, width: '100%' }}>
							<h5 style={{ textAlign: 'center' }}>Quotations</h5>
							<div
								style={{
									paddingLeft: 20,
									paddingRight: 20,
									display: 'flex',
									justifyContent: 'center',
									alignItems: 'center',
									gap: 10,
									paddingBottom: 4
								}}
							>
						</div>
						</div>
					</div>
					<div
						style={{
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center',
							gap: 10,
							paddingTop: 0,
							paddingBottom: 5,
							paddingLeft: 20,
							paddingRight: 20
						}}
						className="show-on-mobile"
					>
						<form className="form-inline navbar-search" style={{ flex: 1 }}>
							<div style={{ position: 'relative', width: '100%' }}>
								<input
									type="text"
									className="form-control bg-white border"
									placeholder="Search"
									aria-label="Search"
									aria-describedby="basic-addon2"
									value={searchValue || ''}
									onChange={handleSearch}
									style={{ width: '100%', paddingRight: 36 }}
								/>
								<span
									className="searchIcon"
									style={{
										position: 'absolute',
										right: 10,
										top: '50%',
										transform: 'translateY(-50%)',
										color: '#888',
										pointerEvents: 'none'
									}}
								>
									<FaSearch />
								</span>
							</div>
						</form>
						<div style={{ flexShrink: 0 }}>
							<Filter
								activeFilters={activeFilters}
								onSubmit={setActiveFilters}
								filters={filters}
								multi={undefined}
								source={`quotation`}
							/>
						</div>
					</div>
					<div className="flex justify-between" style={{ marginTop: '10px' }}>
						<h5
							className="hide-on-mobile"
							style={{
								color: '#17181A',
								fontWeight: 600,
								marginTop: '10px',
								marginLeft: '5px'
							}}
						>
							Quotations
						</h5>
					</div>
					<div
						className={`card shadow-sm  bg-white table-card ${Object.keys(activeFilters).length !== 0 ? 'has-filter' : ''} mt-3 ${
							isMobile ? 'shorter-table' : ''
						}`}
					>
						<div className=" align-items-center justify-content-between TableSerachBar">
							<div>
								<Filter
									activeFilters={activeFilters}
									onSubmit={setActiveFilters}
									filters={filters}
									multi={undefined}
									source={`quotation`}
								/>
							</div>
							<form className="form-inline navbar-search" style={{ display: 'flex', gap: '5px' }} onSubmit={(e) => e.preventDefault()}>
								<div className="input-group">
									<input
										type="text"
										className="form-control bg-white border"
										placeholder="Search"
										aria-label="Search"
										aria-describedby="basic-addon2"
										// value={searchField}
										value={searchValue || ''}
										onChange={handleSearch}
										style={{ width: '100%' }}
									/>
									<span className="searchIcon">
										<FaSearch />
									</span>
								</div>
							</form>
						</div>
						<div className="estimation-table-area">
							<div className="table-side">

							{
								!isMobile ? (
									<div
										className="table-responsive-xl tableData estimationList mt-3"
										ref={tableRef}
										style={{
											height: 'calc(100vh - 260px)',
											overflowY: 'auto',
											scrollbarWidth: 'thin',
											scrollbarColor: '#0966ff transparent'

										}}
									>
										<table className="table  min-width-unset tbl-space pm-table d-none d-md-table">
											<thead>
												<tr className="sticky-header">
													<th scope="col" width="">
														<SortableHeader
															name={`quotation_number`}
															currentSortBy={sortByFilter}
															onClick={() => {
																updateSortByStatus('quotation_number');
															}}
														>
															Reference
														</SortableHeader>
													</th>

													<th scope="col" width="">
														<SortableHeader
															name="manager"
															currentSortBy={sortByFilter}
															onClick={() => {
																updateSortByStatus('manager');
															}}
														>
															Manager
														</SortableHeader>
													</th>
													<th scope="col">
														<SortableHeader
															name="date"
															currentSortBy={sortByFilter}
															onClick={() => {
																updateSortByStatus('date');
															}}
														>
															Date
														</SortableHeader>
													</th>

													<th scope="col">
														<SortableHeader
															name="qty"
															currentSortBy={sortByFilter}
															onClick={() => {
																updateSortByStatus('qty');
															}}
														>
															Qty
														</SortableHeader>
													</th>
													<th scope="col" style={{ width: '110px' }}>
														<SortableHeader
															name="status"
															currentSortBy={sortByFilter}
															onClick={() => {
																updateSortByStatus('status');
															}}
															style={{ maxWidth: '100px' }}
														>
															Status
														</SortableHeader>
													</th>
												</tr>
											</thead>
											<tbody>
												{isLoading ? (
													[...Array(50)].map((e, i) => (
														<tr style={{ height: '35px' }} key={i}>
															{[...Array(5)].map((e, i) => (
																<td>
																	<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
																</td>
															))}
														</tr>
													))
												) : (
													<>
														{dataList?.length > 0 && (
															dataList?.map((item, index) => {

																const maxCharacters = 20;
																const salesPersonFullName = `${item?.sales_person?.first_name || ''} ${item?.sales_person?.last_name || ''}`;
																const truncatedSalesPersonFullName = salesPersonFullName && salesPersonFullName.length > maxCharacters ? salesPersonFullName.substring(0, maxCharacters) + '...' : salesPersonFullName;
																return (
																	<tr style={{ background: `${checkedItems.includes(item.id) ? '#d9e7ff' : 'revert-layer'}` }} key={index}>
																			
																		<td
																			className={`cursor-pointer align-middle font14`}
																			onClick={(e) => {
																				history(`/client/quotations/${item?.quotation_number}?ref=${item?.ref}`);
																			}}
																		>
																			<Link to={`/client/quotations/${item?.quotation_number}`} className="text-black">
																				{item?.master_status?.name == 'Draft' ? (
																					<span style={{ fontStyle: 'italic', color: '#929598' }}>{item?.quotation_number}</span>
																				) : (
																					item?.quotation_number
																				)}
																			</Link>
																		</td>
																		<td
																			className={`cursor-pointer align-middle font14`}
																			onClick={(e) => {
																				history(`/client/quotations/${item?.quotation_number}?ref=${item?.ref}`);
																			}}
																		>
																			<Link to={`/client/quotations/${item?.quotation_number}`} className="text-black">
																				{item?.sales_person?.first_name ? truncatedSalesPersonFullName : '-'}
																			</Link>
																		</td>
																		<td
																			className={`cursor-pointer align-middle font14`}
																			onClick={(e) => {
																				history(`/client/quotations/${item?.quotation_number}?ref=${item?.ref}`);
																			}}
																		>
																			<Link to={`/client/quotations/${item?.quotation_number}`} className="text-black">
																				{`${moment(item?.start_date).format(CommonDateOnlyFormat)}`}
																			</Link>
																		</td>
																		<td
																			className={`cursor-pointer align-middle font14`}
																			onClick={(e) => {
																				history(`/client/quotations/${item?.quotation_number}?ref=${item?.ref}`);
																			}}
																		>
																			<Link to={`/client/quotations/${item?.quotation_number}`} className="text-black">
																				{item?.item_qty?.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}
																			</Link>
																		</td>
																		<td
																			className={`cursor-pointer align-middle font14`}
																			onClick={(e) => {
																				history(`/client/quotations/${item?.quotation_number}?ref=${item?.ref}`);
																			}}
																		>
																			<Link to={`/client/quotations/${item?.quotation_number}`} className="text-black">
																				<StatusBadge itemStatus={item?.master_status?.name} />
																			</Link>
																		</td>
																	</tr>
																);
															})
														)}
														{showPreloadingRows && (
															[...Array(100)].map((e, i) => (
																<tr>
																	{[...Array(5)].map((e, i) => (
																		<td>
																			<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
																		</td>
																	))}
																</tr>
															))
														)}
														{(dataList?.length < 1 && !isLoading) && (
															<tr className="no-hover">
																<td colSpan={5}>
																	<div className="not-found-container">
																		<div className="not-found-icon">
																			<img src={NoRecordFoundIcon} style={{ height: '200px', width: '200px' }} />
																		</div>
																		<h6 className="not-found-text">No Data Available</h6>
																	</div>
																</td>
															</tr>
														)}
													</>
												)}
											</tbody>
										</table>
									</div>
								) : (
									<div
										className="table-responsive-xl tableData estimationList"
										ref={tableRef}
										style={{
											height: `calc(100dvh - ${Object.keys(activeFilters).length === 0 ? '273px' : '300px' })`,
											overflowY: 'auto',
											display: 'flex',
											flexDirection: 'column'
										}}
									>
									
										{isLoading ? (
											<div className="inv-cards-list d-md-none">
												{[...Array(15)].map((_, idx) => (
													<div
														key={idx}
														className="order-list-card"
														style={{
															background: idx % 2 === 0 ? '#f9f9f9' : '#fff',
															borderRadius: 12,
															padding: 16,
															display: 'flex',
															flexDirection: 'column',
															gap: 10
														}}
													>
														{[...Array(2)].map((__, i) => (
															<div key={i} style={{ width: i === 0 ? '60%' : i === 1 ? '40%' : '80%' }}>
																<Skeleton variant="rounded" width={'100%'} height={18} style={{ borderRadius: '8px' }} />
															</div>
														))}
													</div>
												))}
											</div>
										) : (
											<div
												className="inv-cards-list d-md-none"
											>
												{dataList?.map((item, index) => (
													<div
														className="order-list-card active-action"
														style={{
															background: index % 2 === 0 ? '#f9f9f9' : '#fff'
														}}
														onClick={() => {
															history(`/client/quotations/${item?.quotation_number}?ref=${item?.ref}`);
														}}
													>
														<div className="order-list-card-header">
															<h6 className="order-no">

																{item?.master_status?.name == 'Draft' ? (
																	<span style={{ fontStyle: 'italic', color: '#929598' }}>{item?.quotation_number}</span>
																) : (
																	<span className="fw-500">Quotation # {item?.quotation_number}</span>
																)}
															</h6>
															<p className="order-date">{moment(item?.start_date).format(CommonDateOnlyFormat)}</p>
														</div>

														<div className="order-list-card-body">
															<div className="order-contacts">
																<p className="order-customer">
																	Ordered Qty: {item?.item_qty}
																</p>
															</div>
															<p className="total-val" style={{ color: statusColorMap[item?.master_status?.name] || '#acacac' }}>
																<StatusBadge itemStatus={item?.master_status?.name} />
															</p>
														</div>
													</div>
												))}

												{(dataList?.length < 1 && !isLoading) && (
													<div className="w-100">
														<div className="not-found-container">
															<div className="not-found-icon">
																<TbDatabaseExclamation />
															</div>
															<h6 className="not-found-text">No Data Available</h6>

														</div>
													</div>
												)}
											</div>
										)}
									</div>
								)
							}
								<div
									className="hide-on-mobile"
									style={{
										padding: '10px 0 0 20px',
										borderTop: '1px solid #e0e0e0e0',
										display: 'flex',
										gap: '5px',
										justifyContent: 'space-between',
									height: '40px',
									}}
								>

									<div className="flex align-items-center" style={{ gap: '10px' }}>
									{
										showDeleteButton && (
											<>
												<button
													className="btn btn-danger btn-outlined-main-danger white-va"
													onClick={() => {
														setShowDeleteModal(true);
													}}
												>
													Delete
												</button>
												<div>
													<span className="text-gray-800">Selected:</span>{' '}
													<span className="fw-500">
														{checkedItems.length ? checkedItems.length.toLocaleString('en-US') : 0}
													</span>
												</div>
											</>
										)
									}
									</div>
									<div className="flex align-items-center ml-auto" style={{ gap: '5px', paddingRight: '25px' }}>
								
										{isLoading ? (
											<div style={{ width: '100px' }}>
												<Skeleton variant="rounded" width={'100%'} height={20}></Skeleton>
											</div>
										) : (
											<>
												<div className="text-gray-800">Total Record:</div>
												<div className="fw-500">
													{totalRecords.toLocaleString('en-US')}
												</div>
											</>
										)}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>


			{show && (
				<DeleteConfirmationGlass
					show={show}
					handleClose={handleClose}
					customDeleteButtonText={show?.master_status?.name == 'Estimated' ? 'Confirm' : 'Delete'}
					handleDelete={() => {
						if (
							show.master_status?.name == 'Estimated' ||
							show.master_status?.name == 'Pending Manager' ||
							show.master_status?.name == 'Pending'
						) {
							handleCancelEstimate(show?.id);
						} else {
							handleDeleteDraft(show?.id);
						}
					}}
					title={
						show.master_status?.name == 'Estimated' ||
						show.master_status?.name == 'Pending Manager' ||
						show.master_status?.name == 'Pending'
							? 'Confirm Cancel'
							: 'Confirm Delete'
					}
					message={
						show.master_status?.name == 'Estimated' ||
						show.master_status?.name == 'Pending Manager' ||
						show.master_status?.name == 'Pending'
							? `Are you sure you want to cancel estimate ${show.estimation_number}`
							: `Are you sure you want to delete ${show.draft_number || show.estimation_number}`
					}
				/>
			)}

			{showExportModal && !isMobile && (
				<ExportListItemsModal
					openpopup={true}
					disablepopup={() => {
						setShowExportModal(false);
						dispatch(
							storeHeaderActions({
								showQuickStats: headerActions?.showQuickStats,
								showExport: false
							})
						);
					}}
					filters={filters}
					moduleName={'Orders'}
					onSubmit={exportListSubmitHandler}
					historyApi={api.getExportsHistory('orders')}
					isLoading={exportCompIsLoading}
					exportHistoryPerms={['Show Estimation Export History (Button)']}
				/>
			)}

			{showExportModal && isMobile && (
				<ExportListItemsModalMobile
					openpopup={true}
					disablepopup={() => {
						setShowExportModal(false);
						dispatch(
							storeHeaderActions({
								showQuickStats: headerActions?.showQuickStats,
								showExport: false
							})
						);
					}}
					filters={filters}
					moduleName={'Orders'}
					onSubmit={exportListSubmitHandler}
					historyApi={api.getExportsHistory('orders')}
					isLoading={exportCompIsLoading}
					exportHistoryPerms={['Show Estimation Export History (Button)']}
				/>
			)}

			{showDeleteModal && (
				<DeleteConfirmationGlass
					show={showDeleteModal}
					handleClose={handleClose}
					customDeleteButtonText={`Delete`}
					handleDelete={handleDeleteMultipleRecords}
					title={`Confirmation`}
					message={`Are you sure you want to delete ${checkedItems.length} selected records from invoices?`}
				/>
			)}
		</>
	);
};

export default index;
